import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function Navbar() {
  const { count } = useCart();
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: scrolled ? 'rgba(10,12,16,0.96)' : 'transparent',
      borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent',
      backdropFilter: scrolled ? 'blur(12px)' : 'none',
      transition: 'all 0.3s', padding: '0 32px',
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 64,
      }}>
        {/* Logo */}
        <Link to="/">
          <img src="/images/OG W Skull.png" alt="OG-TECH Shop"
            style={{ height: 48, width: 'auto', filter: 'drop-shadow(0 0 8px rgba(0,240,255,0.3))' }} />
        </Link>

        {/* Desktop center links */}
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }} className="shop-nav-desktop">
          {[
            { to: '/', label: 'Shop' },
            { to: '/about', label: 'About' },
          ].map(l => (
            <Link key={l.to} to={l.to} style={{
              fontFamily: 'DM Mono', fontSize: 13, letterSpacing: 2,
              textTransform: 'uppercase', padding: '6px 14px', borderRadius: 6,
              color: pathname === l.to ? 'var(--pink)' : 'var(--muted)',
              background: pathname === l.to ? 'var(--pink-dim)' : 'transparent',
              transition: 'all 0.15s',
            }}>
              {l.label}
            </Link>
          ))}
        </div>

        {/* Right side: cart + burger */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Link to="/cart" style={{
            position: 'relative', display: 'flex', alignItems: 'center', gap: 8,
            fontFamily: 'DM Mono', fontSize: 13, letterSpacing: 2,
            textTransform: 'uppercase', color: 'var(--muted)',
            padding: '6px 14px', borderRadius: 6,
            border: '1px solid var(--border)',
            transition: 'all 0.15s',
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <span className="cart-label">Cart</span>
            {count > 0 && (
              <span style={{
                position: 'absolute', top: -6, right: -6,
                background: 'var(--pink)', color: '#000',
                fontFamily: 'DM Mono', fontSize: 9,
                width: 18, height: 18, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {count}
              </span>
            )}
          </Link>

          {/* Mobile hamburger */}
          <button
            onClick={() => setOpen(o => !o)}
            style={{
              display: 'none', background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text)', width: 36, height: 36, borderRadius: 6,
              alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer',
            }}
            className="shop-nav-burger"
          >
            {open ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div style={{
          background: '#070a0f', borderTop: '1px solid var(--border)',
          padding: '12px 0',
        }}>
          {[
            { to: '/', label: 'Shop' },
            { to: '/about', label: 'About' },
            { to: '/cart', label: `Cart${count > 0 ? ` (${count})` : ''}` },
          ].map(l => (
            <Link key={l.to} to={l.to} style={{
              display: 'block', padding: '10px 32px',
              fontFamily: 'DM Mono', fontSize: 12, letterSpacing: 2,
              textTransform: 'uppercase',
              color: pathname === l.to ? 'var(--pink)' : 'var(--muted)',
              borderLeft: `3px solid ${pathname === l.to ? 'var(--pink)' : 'transparent'}`,
            }}>
              {l.label}
            </Link>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .shop-nav-desktop { display: none !important; }
          .shop-nav-burger { display: flex !important; }
          .cart-label { display: none; }
        }
      `}</style>
    </nav>
  );
}
